import axios from 'axios';
import {useMutation} from '@tanstack/react-query';

import {Keys} from 'client/api/_keys';
import {Routes} from 'client/api/_routes';

import {authAtom} from 'store';
import {useSetRecoilState} from 'recoil';

import {onEditUserRes} from './helper';

const requestConfig = {headers: {'content-type': 'multipart/form-data'}};

export const editUser = async (data: UserReqT) =>
  axios.post(Routes.EDIT_USER, data, requestConfig);

export const useEditUser = () => {
  const setAuth = useSetRecoilState(authAtom);

  return useMutation({
    mutationKey: [Keys.EDIT_USER_MUT],
    mutationFn: editUser,
    onSuccess: res => {
      onEditUserRes({auth: res.data, setAuth});
      return res;
    },
  });
};
